module.exports = __webpack_public_path__ + "static/media/gearbox.5a0b9011.png";